import React, { PureComponent } from "react";
import Logout from "../account/log_out/LogOut";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import PDPADialog from "./components/PDPADialog";
import TermsConditionsDialog from "./components/TermsConditionsDialog";
import { Route } from "react-router-dom";
import AirconImg from "./img/aircon.png";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import AppConfig from "../../config/appconfig.json";
import VerticalSpace from "./components/VerticalSpace";
// import Swipeable from 'react-swipeable';

export default class UserGreeting extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      username: props.username,
      checkpdpa: false,
      checkterms: false,
      modal: false,
      isSubscribed: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // if (typeof AppConfig.applicationServerPublicKey === 'undefined') {
    //   this.errorHandler('Vapid public key is undefined.');
    //   return;
    // }

    // Notification.requestPermission().then(function (status) {
    //   if (status === 'denied') {
    //     this.errorHandler('[Notification.requestPermission] Browser denied permissions to notification api.');
    //   } else if (status === 'granted') {
    //     console.log('[Notification.requestPermission] Initializing service worker.');
    //     // this.initialiseServiceWorker();
    //     let serviceWorker = '/service-worker.js';
    //     if ('serviceWorker' in navigator) {
    //       navigator.serviceWorker.register(serviceWorker).then(function (reg) {
    //         if (reg.installing) {
    //           console.log('Service worker installing');
    //         } else if (reg.waiting) {
    //           console.log('Service worker installed');
    //         } else if (reg.active) {
    //           console.log('Service worker active');
    //         }

    //         // this.initialiseState(reg);
    //         if (!(reg.showNotification)) {
    //           this.errorHandler('[initialiseState] Notifications aren\'t supported on service workers.');
    //           return;
    //         }

    //         // Check if push messaging is supported
    //         if (!('PushManager' in window)) {
    //           this.errorHandler('[initialiseState] Push messaging isn\'t supported.');
    //           return;
    //         }

    //         // We need the service worker registration to check for a subscription
    //         navigator.serviceWorker.ready.then(function (reg) {
    //           // Do we already have a push message subscription?
    //           reg.pushManager.getSubscription()
    //             .then(function (subscription) {
    //               let isSubscribedStatus = subscription;
    //               // this.setState({ isSubscribed: isSubscribedStatus });
    //               if (isSubscribedStatus) {
    //                 console.log('User is already subscribed to push notifications');
    //               } else {
    //                 console.log('User is not yet subscribed to push notifications');
    //               }
    //             })
    //             .catch(function (err) {
    //               console.log('[req.pushManager.getSubscription] Unable to get subscription details.', err);
    //             });
    //         });
    //       });
    //     } else {
    //       this.errorHandler('[initialiseServiceWorker] Service workers are not supported in this browser.');
    //     }
    //   }
    // });

    // this.subscribe();
  }

  // subscribe() {
  //   navigator.serviceWorker.ready.then(function (reg) {
  //     let subscribeParams = { userVisibleOnly: true };

  //     //Setting the public key of our VAPID key pair.
  //     let base64String = AppConfig.applicationServerPublicKey;
  //     let padding = '='.repeat((4 - base64String.length % 4) % 4);
  //     let base64 = (base64String + padding)
  //       .replace(/-/g, '+')
  //       .replace(/_/g, '/');

  //     let rawData = window.atob(base64);
  //     let outputArray = new Uint8Array(rawData.length);

  //     for (let i = 0; i < rawData.length; ++i) {
  //       outputArray[i] = rawData.charCodeAt(i);
  //     }
  //     let applicationServerKey = outputArray;

  //     subscribeParams.applicationServerKey = applicationServerKey;

  //     reg.pushManager.subscribe(subscribeParams)
  //       .then(function (subscription) {
  //         //this.setState({ isSubscribed: true });

  //         //let p256dhKey = subscription.getKey('p256dh');
  //         //let p256dh = btoa(String.fromCharCode.apply(null, new Uint8Array(p256dhKey)));
  //         //let authKey = subscription.getKey('auth')
  //         //let auth = btoa(String.fromCharCode.apply(null, new Uint8Array(authKey)));

  //         // console.log(subscription);
  //         // console.log(subscription.endpoint);
  //         // console.log(p256dh);
  //         // console.log(auth);
  //       })
  //       .catch(function (e) {
  //         if (typeof e === 'undefined') {
  //           e = null;
  //         }

  //         console.error('[subscribe] Unable to subscribe to push', e);
  //       });
  //   });
  // }

  // errorHandler(message, e) {
  //   if (typeof e === 'undefined') {
  //     e = null;
  //   }

  //   console.error(message, e);
  // }

  // base64Encode(arrayBuffer) {
  //   return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
  // }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const AddNewAirconSystemLink = props => (
      <Route
        render={({ history }) => (
          <div>
            <a
              onClick={() => {
                history.push({ pathname: "/register_aircon" });
              }}
            >
              Add New System
            </a>
          </div>
        )}
      />
    );

    const ProceedButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              type="submit"
              onClick={() => {
                if (this.state.checkpdpa && this.state.checkterms) {
                  let isSaveAgreementFailed = false;
                  const kbeSid = localStorage.getItem("kbeSid");
                  if (kbeSid) {
                    const request = {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        Sid: kbeSid
                      })
                    };
                    // Call Back-End Services
                    fetch(
                      `${AppConfig.BACK_END_URL}/APIClient/SaveAgreement`,
                      request
                    )
                      .then(response => {
                        // console.log(response);
                        if (response.ok === false) {
                          isSaveAgreementFailed = true;
                        }
                        return response.json();
                      })
                      .then(json => {
                        if (isSaveAgreementFailed) {
                          const respObj = JSON.parse(json);
                          console.log(respObj.Message);
                        } else {
                          localStorage.setItem("kbeAgreement", true);
                          history.push({ pathname: "/register_aircon" });
                        }
                      })
                      .catch(() => {
                        console.log(
                          "Something went wrong when saving agreement. Please try again."
                        );
                      });
                  }
                } else
                  alert("Please accept the PDPA and the terms and conditions");
              }}
            >
              Proceed
            </Button>
          </div>
        )}
      />
    );

    return (
      <div>
        <div className="account__main">
          {this.props.isAgreementAccepted ? (
            <div>
              Welcome
              {this.state.username ? " " + this.state.username : ""}
            </div>
          ) : (
              <div>
                Welcome
              {this.state.username ? " " + this.state.username : ""},
              <div>
                  Please share some details with us so we can better serve you
              </div>
              </div>
            )}
          <div>
            <Logout />
          </div>
          {this.props.isAgreementAccepted ? (
            <div>
              <div className="form form--horizontal">
                <div className="form__form-group">
                  <div className="form__form-group-label" />
                  <div className="form__form-group-field" />
                </div>
                {this.props.custSystemList.map(function (system, index) {
                  return (
                    <Route
                      key={index}
                      render={({ history }) => (
                        <ListItem button>
                          <Grid container spacing={0}>
                            <Grid item xs={3} onClick={function () {
                              history.push({
                                pathname: "/aircon_record",
                                state: { airconsystem: system }
                              });
                            }}>
                              <ListItemText>
                                <img src={AirconImg} alt="aircon" />
                              </ListItemText>
                            </Grid>
                            <Grid item xs={7} onClick={function () {
                              history.push({
                                pathname: "/aircon_record",
                                state: { airconsystem: system }
                              });
                            }}>
                              <ListItemText>
                                <div className="list-text">
                                  {system.Brand} {system.Type} {system.Model}
                                </div>
                                <div className="list-text">
                                  {system.Street} {system.Block}{" "}
                                  {system.PostalCode}
                                </div>
                                <div className="list-text">
                                  Last Servicing: {system.LastServicing}
                                </div>
                                <div className="list-text">
                                  Servicing Due: {system.ServicingDue}
                                </div>
                              </ListItemText>
                            </Grid>
                            <Grid item xs={2}>
                              <Button
                                variant="outlined"
                                type="button" onClick={() => {
                                  history.push({
                                    pathname: "/register_aircon",
                                    state: { airconsystem: system }
                                  });
                                }}>Edit</Button>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )}
                    />
                  );
                })}
                <ListItem>
                  <Grid container spacing={0}>
                    <Grid item xs={3}>
                      <ListItemText>
                        <img src={AirconImg} alt="aircon" />
                      </ListItemText>
                    </Grid>
                    <Grid item xs={9}>
                      <ListItemText>
                        <AddNewAirconSystemLink />
                      </ListItemText>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider />
              </div>
              <VerticalSpace />
            </div>
          ) : (
              <div>
                <div>
                  <center>
                    <ProceedButton />
                  </center>
                </div>
                <br />
                <div>
                  <label>
                    <Checkbox
                      name="checkpdpa"
                      color="primary"
                      checked={this.state.checkpdpa}
                      onChange={this.handleInputChange}
                    />
                    I have read and agree to the{" "}
                  </label>
                  <PDPADialog />
                </div>
                <div>
                  <label>
                    <Checkbox
                      name="checkterms"
                      color="primary"
                      checked={this.state.checkterms}
                      onChange={this.handleInputChange}
                    />
                    I have read and agree to the{" "}
                  </label>
                  <TermsConditionsDialog />
                </div>
              </div>
            )}
          <div />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/UserGreeting.js